import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllPayments(page, limit) {
  return httpClient.get('/merchant/payments', {
    params: {
      page,
      limit,
    },
  });
}

/**
 *
 * @param paymentId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getPayment(paymentId) {
  return httpClient.get(`/merchant/payments/${paymentId}`);
}

/**
 *
 * @param paymentId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deletePayment(paymentId) {
  return httpClient.delete(`/merchant/payments/${paymentId}`);
}

/**
 *
 * @param paymentId
 * @param payment
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updatePayment(paymentId, payment) {
  return httpClient.put(`/merchant/payments/${paymentId}`, payment);
}

/**
 *
 * @param payment
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newPayment(payment) {
  return httpClient.post('/merchant/payments', payment);
}

// Merchant Specific APIs ends
// =========================================
